/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FaxModuleProvider
 */
export interface FaxModuleProvider {
    /**
     * 
     * @type {string}
     * @memberof FaxModuleProvider
     */
    provider_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FaxModuleProvider
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FaxModuleProvider
     */
    send_from_email?: string;
    /**
     * Number of faxN.tenantId@ SES addresses in the pool (e.g. 5 means fax1 through fax5)
     * @type {number}
     * @memberof FaxModuleProvider
     */
    ses_fax_pool_size?: number;
}

/**
 * Check if a given object implements the FaxModuleProvider interface.
 */
export function instanceOfFaxModuleProvider(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FaxModuleProviderFromJSON(json: any): FaxModuleProvider {
    return FaxModuleProviderFromJSONTyped(json, false);
}

export function FaxModuleProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxModuleProvider {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider_id': !exists(json, 'provider_id') ? undefined : json['provider_id'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'send_from_email': !exists(json, 'send_from_email') ? undefined : json['send_from_email'],
        'ses_fax_pool_size': !exists(json, 'ses_fax_pool_size') ? undefined : json['ses_fax_pool_size'],
    };
}

export function FaxModuleProviderToJSON(value?: FaxModuleProvider | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider_id': value.provider_id,
        'enabled': value.enabled,
        'send_from_email': value.send_from_email,
        'ses_fax_pool_size': value.ses_fax_pool_size,
    };
}

